<template>
  <div>
    <div class="about">
      <div class="photo-content2">
        <img src="@/assets/img/about/01.png">
        <div class="mask"></div>
        <router-link to="/group-overview"></router-link>
        <p>公司概况</p>
      </div>
      <div class="photo-content2">
        <img src="@/assets/img/about/02.png">
        <div class="mask"></div>
        <router-link to="/recruit"></router-link>
        <p>人才招聘</p>
      </div>
      <div class="photo-content2">
        <img src="@/assets/img/about/03.png">
        <div class="mask"></div>
        <router-link to="/contact-us"></router-link>
        <p>联系我们</p>
      </div>
      <div class="photo-content2">
        <img src="@/assets/img/about/04.png">
        <div class="mask"></div>
        <router-link to="/chairman-message"></router-link>
        <p>董事长寄语</p>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer'
export default {
  name: 'About',
  components: {
    Footer
  }
}
</script>
<style lang="less" scoped>
@import '../../less/about.less';
</style>
